import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import * as actions from '../actions/homeActions';
import { Field, reduxForm, initialize, formValueSelector } from 'redux-form';
import ReactGA from 'react-ga';
import * as homeActions from '../actions/homeActions';
import * as pricingActions from '../actions/pricingActions';
import LoadingOverlay from '../components/LoadingOverlay';
import { getEndDateFromStartDateAndDurationUnit,getDateString } from '../utils/dates';
import { getDurationUnits } from '../utils/durationUnits'
import { DateTimePicker,DatePicker  } from 'react-rainbow-components';


export  class EditSpecialDealDetailForm extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            cookiesAccepted: false,
        };
    }

      componentDidMount(){
        window.addEventListener('CookiebotOnAccept', () => {
            this.setState({ cookiesAccepted: true });
        });
    }

    componentWillUnmount() {
        window.removeEventListener('CookiebotOnAccept', () => {
            this.setState({ cookiesAccepted: false });
        });
    }

    handlerFromTimeChange(time){
        
        this.props.homeActions.updateBookingFromDate(time);
        let toDate=getEndDateFromStartDateAndDurationUnit(time,this.props.locationDetail.selectedOffering.pricing.duration,getDurationUnits(this.props.locationDetail.selectedOffering.pricing.durationUnits))
        this.props.homeActions.updateBookingToDate(toDate);
        this.props.homeActions.checkSpaceAvailable(getDateString(time));
      }

      handlerSubmit=()=>{

        this.toggle();
    
      }


    toggle() {      
        this.props.toggle();
    }


    render(){
        const {

            isOpen,
            handleSubmit,
            isLoading
  
        } = this.props;
        let{selectedOffering,startDate,untilDate,spaceAvailable}=this.props.locationDetail;
        let{dealPricingModel}=this.props.pricing;
      return (
          selectedOffering ?
            <Modal isOpen={isOpen}
                backdrop={"static"}
                className={"modalChangeVehicle"}
                toggle={() => this.toggle(!isOpen)}>
                    <ModalHeader toggle={() => this.toggle()}>{selectedOffering.name}</ModalHeader>
                    <ModalBody>
                    <div className="card">
                
                <form onSubmit={handleSubmit}>
                    <div className="row mb-3">
                        <label htmlFor="startTime" className="col-sm-4 col-form-label form_label"><b>From</b></label>
                        <div className="col-sm-8 text-center">

                        <div
        className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto mt-4"

    >
        <DateTimePicker
            value={startDate}
            onChange={(e)=>this.handlerFromTimeChange(e)}
            className="rainbow-m-around_small"
            hour24
            minDate={new Date(startDate)}
            locale="en-IE"
        />
    </div>

                        </div>
    
                        
                    </div>
                    <div className="row mb-3">
                        <label htmlFor="untilTime" className="col-sm-4 col-form-label form_label"><b>Until</b></label>
                        <div className="col-sm-8 text-center">
                        <div
        className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto mt-4"

    >
        <DateTimePicker
            value={untilDate}
            className="rainbow-m-around_small"
            hour24
            locale="en-IE"
            disabled
        />
    </div>

                        </div>
    
                        
                    </div>
                    <div className="row md-3">
                        <div className="col-sm-12">
                        <LoadingOverlay className="balance" loading={isLoading} >
                        <div className="border-section">
                            <div className="info">
                                <h4 className="text-center mb-0">
                                    <strong>{ !isLoading &&  spaceAvailable? `€ ${dealPricingModel.totalAmount?dealPricingModel.totalAmount.toFixed(2):0}`: `No Space Available` }</strong>
                                </h4>
                            </div>
                        </div>
                    </LoadingOverlay>
    
                        </div>
    
                    </div>
                    <div className="row">
                        <div className="col-sm-12 text-center">
                            <button className="btn btn-primary" disabled={!spaceAvailable} type="submit" >Proceed To Checkout</button>
                        </div>
                    </div>
    
                    
                </form>
            
            
        </div>
                    </ModalBody>

                </Modal> : null
        );
    }
}
EditSpecialDealDetailForm.propTypes={
    isOpen:PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    homeActions:PropTypes.object.isRequired,
    pricingActions:PropTypes.object.isRequired,
    locationDetail:PropTypes.object,
    pricing:PropTypes.object,
    isLoading:PropTypes.bool


}

function mapStateToProps(state) {
    return {
      locationDetail: state.locationDetail,
      pricing:state.pricing
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      homeActions: bindActionCreators(homeActions, dispatch),
      pricingActions: bindActionCreators(pricingActions, dispatch)
    };
  }


  export default connect(
    mapStateToProps,
    mapDispatchToProps
)(reduxForm({
    form: 'editSpecialDealDetailForm',
    onSubmitSuccess: (result, dispatch, props) => {
        dispatch(initialize(props.form, props.values));
        if (this.state.cookiesAccepted) {
            ReactGA.event({
                category: 'service',
                action: 'special deal detail'
            });
        }
    }
})(EditSpecialDealDetailForm));





// WEBPACK FOOTER //
// ./src/forms/EditSpecialDealDetailForm.jsx